module.exports = __webpack_public_path__ + "img/software_content.6c381e13.png";